import Vue from 'vue'
import VueRouter from 'vue-router'
import SignIn from '../views/SignIn.vue'
import SignUp from '../views/SignUp.vue'
import Home from '../views/Home.vue'
import CategoryDetail from '../views/CategoryDetail.vue'
import ListingDetail from '../views/ListingDetail.vue'
import OfferPage from '../views/OfferPage.vue'
import Profile from '../views/User/Profile.vue'
import MyTrades from '../views/User/MyTrades.vue'
import AddListing from '../views/AddListing.vue'
import Leaders from '../views/Leaders.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/category/:categoryName?',
    name: 'CategoryDetail',
    component: CategoryDetail
  },
  {
    path: '/listing/:id',
    name: 'ListingDetail',
    component: ListingDetail
  },
  {
    path: '/offer/:id',
    name: 'OfferPage',
    component: OfferPage
  },
  {
    path: '/profile/:id?',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/add-listing',
    name: 'AddListing',
    component: AddListing
  },
  {
    path: '/edit-listing/:id',
    name: 'EditListing',
    component: AddListing
  },
  {
    path: '/my-trades',
    name: 'MyTrades',
    component: MyTrades
  },
    {
    path: '/leaders',
    name: 'Leaders',
    component: Leaders
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router